import { formatDateLabel } from "./dateUtils";
import { formatNumber, isNegative } from "./reportUtils";

const createHiddenDownload = (content, filename) => {
  const link = document.createElement("a");
  link.setAttribute("href", content);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportCashFlowToCSV = (data, filters, toast, texts) => {
  if (!data?.headers || !data?.rows) {
    toast({
      title: texts.reports?.noDataToExport || "No data to export",
      status: "warning",
      duration: 2000,
    });
    return;
  }

  try {
    let csvContent = "data:text/csv;charset=utf-8,\uFEFF";
    csvContent += `${data.headers.join(",")}\r\n`;

    data.rows.forEach((row) => {
      const values = row.values.map((value, index) =>
        index === 0 ? `"${value}"` : formatNumber(value)
      );
      csvContent += `${values.join(",")}\r\n`;
    });

    createHiddenDownload(
      encodeURI(csvContent),
      `${texts.reports?.cashFlow || "Cash_Flow"}_${filters.date_after}_${filters.date_before}.csv`
    );

    toast({
      title: texts.reports?.csvExportSuccess || "CSV exported successfully",
      status: "success",
      duration: 2000,
    });
  } catch {
    toast({
      title: texts.reports?.csvExportError || "CSV export error",
      description: texts.reports?.couldNotGenerateCSV || "Could not generate CSV file",
      status: "error",
      duration: 3000,
    });
  }
};

export const exportCashFlowToPDF = (data, filters, toast, texts, currencies) => {
  if (!data?.headers || !data?.rows) {
    toast({
      title: texts.reports?.noDataToExport || "No data to export",
      status: "warning",
      duration: 2000,
    });
    return;
  }

  const printWindow = window.open("", "_blank");
  if (!printWindow) {
    toast({
      title: texts.reports?.printError || "Print error",
      description: texts.reports?.popupBlocked || "Popup was blocked. Please allow popups for this site.",
      status: "error",
      duration: 3000,
    });
    return;
  }

  const currentCurrency =
    currencies.find((currency) => currency.code === filters.currency) || {
      code: filters.currency,
      symbol: "",
    };

  const htmlContent = `
    <!DOCTYPE html>
    <html dir="rtl">
      <head>
        <meta charset="UTF-8">
        <title>${texts.reports?.cashFlowReport || "Cash Flow Report"}</title>
      </head>
      <body>
        <div>
          <div>${texts.reports?.cashFlowReport || "Cash Flow Report"}</div>
          <div>${texts.reports?.period || "Period"}: ${formatDateLabel(filters.date_after)} - ${formatDateLabel(filters.date_before)}</div>
          <div>${texts.reports?.currency || "Currency"}: ${filters.currency} ${currentCurrency.symbol}</div>
        </div>
        <table border="1" cellspacing="0" cellpadding="4">
          <thead>
            <tr>${data.headers.map((header) => `<th>${header}</th>`).join("")}</tr>
          </thead>
          <tbody>
            ${data.rows
              .map(
                (row) => `
              <tr>
                ${row.values
                  .map((value, index) => {
                    if (index === 0) return `<td>${value}</td>`;
                    const formattedValue = formatNumber(value);
                    const style = isNegative(value) ? ' style="color:#dc3545"' : "";
                    return `<td${style}>${formattedValue}</td>`;
                  })
                  .join("")}
              </tr>`
              )
              .join("")}
          </tbody>
        </table>
      </body>
    </html>
  `;

  printWindow.document.write(htmlContent);
  printWindow.document.close();

  toast({
    title: texts.reports?.openingPrintWindow || "Opening print window",
    description: texts.reports?.windowWillOpenAutomatically || "Window will open automatically for printing",
    status: "info",
    duration: 2000,
  });
};
